module.exports = __webpack_public_path__ + "static/media/photo1.19e6fd5f.jpg";